// extracted by mini-css-extract-plugin
module.exports =  {"section":"section-hcYuV","label":"label-wXG3e"};